import putSendDMS from '../../../../services/charges/dms/putSendDMS'
import { put, call, takeEvery, select } from 'redux-saga/effects'
import { getAuth } from '../../../../selectors/access/auth'
import { yesNoModal } from '../../../modalsListeners/yesNoModal'
import { showLoader, hideLoader, openModal } from '../../../../actions/common'
import { handleError } from '../../../errors/errorManager'
import dms from '../../../../constants/actions/dossier/common/dms'
import {
  closeAddOrEditDocumentModalSuccess
} from '../../../../actions/dossier/common/documentEditionModal'
import backEndTagTranslation from '../../../../constants/backEndTagTransaltion'
import { openErrorMessageModal } from '../../../../actions/modals/messageModal'

export function * sendDMS ({ dossierId, resolve }) {
  try {
    const auth = yield select(getAuth)
    const confirmed = yield call(yesNoModal, 'sendDMS')
    if (confirmed) {
      yield put(showLoader())
      yield call(putSendDMS, dossierId, auth.token)
      yield put(closeAddOrEditDocumentModalSuccess())
    }
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && customHandlerError.json.tag) {
        if (customHandlerError.json.tag.split('#').includes('customError')) {
          let tKeyMessage = ''
          const backEndTag = customHandlerError.json.tag.split('#')[0]
          if (backEndTag && backEndTagTranslation[backEndTag]) {
            tKeyMessage = `<p>#T#ERRORS.BACKEND_TAG_TRANSLATION.${backEndTagTranslation[backEndTag]}#T#</p>`
          }
          yield put(openModal('customError', null, null, tKeyMessage, customHandlerError.json.message, null, null))
        } else {
          yield put(openErrorMessageModal('', customHandlerError.json.tag ? customHandlerError.json.tag : ''))
        }
      } else {
        yield put(openErrorMessageModal('', 'errorSentToDMS'))
      }
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchSendDMS () {
  yield takeEvery(dms.SEND_DMS, sendDMS)
}
